import { useAuth } from '@/context/AuthContext';

import type Premission from './premission.type';

export function useCheckPrems(prem: Premission) {
  const { user } = useAuth();
  return user?.premissions?.includes(prem);
}
